import React from 'react';
import FeatureTile from '../FeatureTile';
import { useTileData } from '../../../hooks/useTileData';
import { getGA4Kpis } from '../../../api';
import { fmtNumber } from '../../shared/format';

const pct = (v) => (v == null ? '—' : `${Number(v).toFixed(1)}%`);

const Icon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 3v17a1 1 0 001 1h17M8 17V9M13 17V5M18 17v-7" />
  </svg>
);

export default function WebsiteAnalyticsTile({ clientId, rangeStart, rangeEnd }) {
  const { data, loading, error } = useTileData(
    async () => {
      const resp = await getGA4Kpis(clientId, rangeStart, rangeEnd);
      return resp?.data ?? null;
    },
    [clientId, rangeStart, rangeEnd],
    Boolean(clientId && rangeStart && rangeEnd),
  );

  // GA4 KPIs live on `.current` when the RPC uses the standard {current, previous}
  // envelope, else on the top-level object. Accept both.
  const src = data?.current || data || null;

  const primary = src ? {
    value: fmtNumber(src.sessions ?? 0),
    label: 'Sessions',
    subtitle: `${fmtNumber(src.users ?? 0)} users`,
  } : null;
  const secondary = src ? [
    { value: pct(src.engagement_rate ?? 0), label: 'Engagement' },
    { value: fmtNumber(src.conversions ?? 0, true), label: 'Conversions' },
  ] : [];

  return (
    <FeatureTile
      title="Website Analytics"
      icon={<Icon />}
      color="amber"
      primary={primary}
      secondary={secondary}
      ctaLabel="Open"
      ctaTo="/google-analytics"
      loading={loading}
      error={error}
    />
  );
}
